import { useSelector } from "react-redux";
import { axInst } from "../../../Components/Login/Service";
import { useEffect, useState } from "react";

const PdfName = () => {
  const { data } = useSelector((e) => e.filtersDealerReview);
  const [statesOffice, setStatesOffice] = useState([]);
  const [dealerNames, setDealerNames] = useState([]);

  const fetchStatesOffice = async (pDealerName, pDealerCode) => {
    try {
      const { data: apiData } = await axInst.post(
        "dealer-review/dealer_review_filter",
        {
          dealer_name: pDealerName || [],
          dealer_code: pDealerCode || [],
        }
      );

      const statesOfficeArray =
        apiData?.STATE?.buckets?.map((e) => e.key) || [];

      // ✅ Pick dealer names from API buckets if they exist
      const dealerNameArray =
        apiData?.DEALER_NAME?.buckets?.map((e) => e.key) || [];

      // fallback: if API didn’t send dealer names, use Redux values
      const apiDealerNames =
        dealerNameArray.length > 0 ? dealerNameArray : pDealerName || [];

      return { statesOfficeArray, apiDealerNames };
    } catch (error) {
      console.error("Error fetching state offices:", error);
      return { statesOfficeArray: [], apiDealerNames: [] };
    }
  };

  useEffect(() => {
    if (data?.dealer_name?.length > 0 || data?.dealer_code?.length > 0) {
      fetchStatesOffice(data?.dealer_name, data?.dealer_code).then(
        ({ statesOfficeArray, apiDealerNames }) => {
          setStatesOffice(statesOfficeArray);
          setDealerNames(apiDealerNames);
        }
      );
    } else {
      setStatesOffice([]);
      setDealerNames([]);
    }
  }, [data?.dealer_name, data?.dealer_code]);

  return (
    <div className="w-full text-[#2A5775] font-bold text-[18px] border-[#2c8a8b] border rounded-md p-2 grid grid-cols-2 gap-4">
      <span>State Office: {statesOffice.join(", ") || "N/A"}</span>
      <span>Dealer Name: {dealerNames.join(", ") || "N/A"}</span>
    </div>
  );
};

export default PdfName;
